<div class="gt-routes-list-containerss height-limit">
  <div class="form-style column" [style.backgroundColor]="'inherit'">
    <div class="grid-view-container">
      <div class="tc-grid-wrapper">
        <div class="custom-toolbar">
          <div class="custom-toolbar-left">
            <dx-text-box
              [(value)]="searchTerm"
              mode="search"
              valueChangeEvent="keyup"
              width="100%"
              class="custom-search-panel"
              (onValueChanged)="componentGrid.instance.searchByText($event.value)"
              i18n-placeholder="@@componentsSearch"
              placeholder="Search components..."
            >
            </dx-text-box>
          </div>

          <app-gpd-button text="ADD COMPONENT" (onClick)="addComponent($event)" icon="add" i18n-text="@@addComponentCaps"></app-gpd-button>
        </div>

        <div class="inner-grid-panel">
          <dx-data-grid
            #componentGrid
            class="gpd-datagrid"
            [dataSource]="projectComponentList"
            (onInitNewRow)="onInitNewRow($event)"
            (onSaved)="saveComponents($event)"
            [hoverStateEnabled]="true"
            [rowAlternationEnabled]="false"
            [selectedRowKeys]="selectedRow"
            [editing]="{ mode: 'form', texts: { saveRowChanges: confirmText, cancelRowChanges: cancelText }}"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [columnAutoWidth]="false"
            [showBorders]="false"
            [scrolling]="{ mode: 'standard', useNative: false, showScrollbar: 'never' }"
            [width]="'100%'"
            [height]="availableHeight + 'px'"
            [showColumnLines]="true"
            [showRowLines]="false"
            (onOptionChanged)="onGridOptionChanged($event)"
            (onContentReady)="getGridPageInfo()"
            (onRowClick)="onRowClick($event)"
          >
            <dxo-editing mode="form"></dxo-editing>
            <dxo-selection mode="single" [allowSelectAll]="false" showCheckBoxesMode="none"></dxo-selection>
            <dxo-paging [enabled]="true" [pageSize]="dynamicPageSize"></dxo-paging>
            <dxo-pager [visible]="false"></dxo-pager>
            <dxo-scrolling mode="standard"></dxo-scrolling>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxi-column i18n-caption="@@model" caption="Model" dataField="model"></dxi-column>
            <dxi-column i18n-caption="@@manufacturer" caption="Manufacturer" dataField="manufacturerName"></dxi-column>
            <dxi-column i18n-caption="@@type" caption="Type" dataField="typeId" [editorOptions]="{readOnly:true}">
              <dxo-lookup [dataSource]="componentTypes" valueExpr="id" displayExpr="name"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="quantity" caption="Quantity" i18n-caption="@@quantityAnzhal" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="none" caption="" cellTemplate="buttonCellTemplate" width="68px"
              [formItem]="{visible: false}" [allowHeaderFiltering]="false">
              <div *dxTemplate="let item of 'buttonCellTemplate'">
                <app-gpd-button icon="edit" type="text" (onClick)="editRow($event, item.data)"></app-gpd-button>
              </div>
            </dxi-column>
          </dx-data-grid>

          <!-- Details Panel -->
          <app-component-details-panel
            [visible]="detailsPanelVisible"
            [componentDetails]="componentDetails"
            [doclinks]="doclinks"
            [componentId]="componentId"
            [documentList]="documentList"
            [sites]="sitesForPanel"
            [projects]="projectsForPanel"
            [disableDownloadAll]="disableDownloadAll"
            [showDownloadAllButton]="!disableDownloadAll"
            (onClose)="closeDetailsPanel()"
            (onEdit)="onEditFromPanel()"
            (onDownloadAll)="downloadAllDocs()"
          ></app-component-details-panel>
        </div>

        <div class="bottom-toolbar">
          <app-gpd-button
            type="tertiary"
            icon="download"
            i18n-text="@@export"
            text="Export"
            (onClick)="exportComponentData()"
          ></app-gpd-button>

          <app-gpd-pagination
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [itemsPerPage]="totalItems === 0 ? 0 : (showingTo - showingFrom + 1)"
            [totalItems]="totalItems"
            (onPageChange)="onPageChange($event)"
          ></app-gpd-pagination>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showErrMsg" class="gpd-overlay">
  <p>{{ errMsg }}</p>
  <div style="margin-top: 30px;"></div>
  <div class="gpd-overlay-footer-center" style="gap: 20px;">
    <app-gpd-button i18n-text="@@closeText" text="Close" (onClick)="closeErrMsg()" type="secondary"></app-gpd-button>
    <app-gpd-button i18n-text="@@goToLibrary" text="Go To Library" (onClick)="goToComponentLibrary()" icon="arrow-right"></app-gpd-button>
  </div>
</div>


<app-generic-popup
  [(visible)]="editComponentVisible"
  (onHiding)="editComponentVisible = false"
  i18n-title="@@editComponent" title="Edit Component"
  [width]="'478px'"
  [leftButtons]="editPopupLeftButtons"
  [buttons]="editPopupButtons"
  [allowOutsideClick]="true"
>
  <p class="gpd-popup-description" i18n="@@editComponentDescriptionProject">
    Adjust how many units of this component are assigned to this project.
  </p>
  <dx-form [formData]="selectedComponent" colCount="2" labelLocation="top" [showColonAfterLabel]="false">
    <dxi-item itemType="group" colCount="2" colSpan="2">
      <dxi-item editorType="dxTextBox" i18n-caption caption="Manufacturer" dataField="manufacturerName"
        colSpan="2" [editorOptions]="{ readOnly: true, stylingMode: 'outlined' }">
        <dxo-label i18n-text="@@manufacturer" text="Manufacturer"></dxo-label>
      </dxi-item>
      <dxi-item editorType="dxNumberBox" i18n-caption caption="Quantity" dataField="quantity" colSpan="2"
        [editorOptions]="{ min: 0, stylingMode: 'outlined' }">
        <dxo-label i18n-text="@@quantityAnzhal" text="Quantity"></dxo-label>
      </dxi-item>
    </dxi-item>
  </dx-form>
</app-generic-popup>


<app-generic-popup
  [(visible)]="addComponentVisible"
  (onHiding)="closeAddComponent()"
  i18n-title="@@addComponentToProject"
  title="Add Component"
  [width]="'700px'"
  [buttons]="addPopupButtons"
  [allowOutsideClick]="true"
>
  <p class="gpd-popup-description" i18n="@@addComponentToProjectDescription">
    Select a component from the library to add it to this project. Only completed components can be added. Enter the quantity once you've made your selection.
  </p>
  <div style="height: 40px; margin-bottom: 8px;">
    <dx-text-box
      [(value)]="addComponentSearchTerm"
      mode="search"
      valueChangeEvent="keyup"
      width="350px"
      class="custom-search-panel"
      (onValueChanged)="addComponentGrid.instance.searchByText($event.value)"
      i18n-placeholder="@@search..."
      placeholder="Search ..."
    >
    </dx-text-box>
  </div>
  <dx-data-grid
    #addComponentGrid
    class="gpd-datagrid"
    [dataSource]="componentList"
    [showRowLines]="false"
    [selectedRowKeys]="[]"
    (onSelectionChanged)="onAddComponentGridSelectionChanged($event)"
    [allowColumnResizing]="true"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="false"
    [showBorders]="true"
    [scrolling]="{ mode: 'standard', useNative: true }"
    [width]="'100%'"
    height="auto"
    [rowAlternationEnabled]="false"
    [hoverStateEnabled]="true"
    [showColumnLines]="true"
    [paging]="{ enabled: true, pageSize: 10 }"
    [pager]="{ visible: false }"
    (onContentReady)="getAddComponentGridPageInfo()"
    (onOptionChanged)="onAddComponentGridOptionChanged($event)"
    (onRowClick)="onComponentRowClick($event)"
    (onRowPrepared)="onAddComponentRowPrepared($event)"
  >
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-selection mode="single"></dxo-selection>
    <dxi-column i18n-caption="@@model" caption="Model" dataField="model"></dxi-column>
    <dxi-column i18n-caption="@@manufacturer" caption="Manufacturer" dataField="manufacturerName"></dxi-column>
    <dxi-column i18n-caption="@@type" caption="Type" dataField="type"></dxi-column>
    <dxi-column
      caption=""
      dataField="isCompleted"
      [allowHeaderFiltering]="false"
      [allowSorting]="false"
      cellTemplate="warningIconTemplate"
      [width]="40"
    >
      <div *dxTemplate="let item of 'warningIconTemplate'">
        <div *ngIf="!item.data.isCompleted" class="warning-icon-wrapper">
          <i class="dx-icon dx-icon-warning warning-icon"></i>
          <span class="warning-tooltip" i18n="@@incompleteComponentTooltip">This component can only be added to projects if it is complete. Please finish it in the library.</span>
        </div>
      </div>
    </dxi-column>
  </dx-data-grid>
  <div class="add-popup-bottom">
    <app-gpd-pagination
      [currentPage]="addComponentCurrentPage"
      [totalPages]="addComponentTotalPages"
      [itemsPerPage]="addComponentTotalItems === 0 ? 0 : (addComponentShowingTo - addComponentShowingFrom + 1)"
      [totalItems]="addComponentTotalItems"
      (onPageChange)="onAddComponentPageChange($event)"
    ></app-gpd-pagination>
    <div *ngIf="showQuantityInput" class="quantity-row">
      <label i18n="@@quantityAnzhal" style="margin: 0; white-space: nowrap;">Quantity:</label>
      <dx-number-box
        [(value)]="addComponentGridSelection.quantity"
        format="#,##0.##"
        style="width: 100%"
      ></dx-number-box>
    </div>
  </div>
</app-generic-popup>
